<template>
    <div id="activityDownload" style="padding:0 20px;background: white" v-if="this.$route.params.studentID">
        <K2Row justify_content="center" class="position-relative p-4 border-bottom">
            <K2Row :style="{background: uiVariable.color.button1}"
                   style="cursor: pointer; border-bottom: 1px solid #eee;"
                   class="backButton pe-3 rounded po"
                   align="center" @onclick="handleBack">
                <K2Icon color="white" name="chevron_left" font-size="29px"/>
                <K2Text color="white">{{lang("Back")}}</K2Text>
            </K2Row>
            <K2Heading type="h5" class-name="mb-0" color="black">{{lang("Download Post")}}</K2Heading>
        </K2Row>
        {{this.$route.params.studentID}}

        <iframe :src="'https://academica.etonhouse.com/Headless/Activities/Report/Students/'+this.$route.params.studentID"
                style="height:100vh"
                width="80%" title="Activity Download"></iframe>
    </div>

    <div id="activityDownload" style="padding:0 20px;background: white" v-else>
        <K2Row justify_content="center" class="position-relative p-4 border-bottom">
            <K2Row :style="{background: uiVariable.color.button1}"
                   style="cursor: pointer; border-bottom: 1px solid #eee;"
                   class="backButton pe-3 rounded po"
                   align="center" @onclick="handleBack">
                <K2Icon color="white" name="chevron_left" font-size="29px"/>
                <K2Text color="white">{{lang("Back")}}</K2Text>
            </K2Row>
            <K2Heading type="h5" class-name="mb-0" color="black">{{lang("Download Post")}}</K2Heading>
        </K2Row>
        <iframe :src="'https://academica.etonhouse.com/headless/Activities/Report/'+this.$route.params.schoolID"
                style="height:100vh"
                width="80%" title="Activity Download"></iframe>
    </div>
</template>
<script>
  import Vue from "vue";
  import uiVariable from "../../config/uiVariable";
  import assets from "../../assets/assets";
  import K2Row from "../../uiComponents/k2Row/k2Row";
  import K2Icon from "../../uiComponents/k2Icon/k2MAIcon";
  import K2Text from "../../uiComponents/k2Text/k2Text";
  import K2Heading from "../../uiComponents/k2Heading/k2Heading";
  import { lang } from "../../locale";
  import Cookies from "js-cookie";

  export default {
    name: "ActivityDownload",
    components: { K2Heading, K2Text, K2Icon, K2Row },
    data() {
      return {
        assets: assets,
        uiVariable: uiVariable,
        isParent: false
      };
    },
    mounted() {
      this.isParent = Cookies.get("userTypeSession") === "Parent";
    },
    methods: {
      lang,
      handleBack() {
        this.$router.push(this.isParent ? "/StaffMainPage" : "/Activity");
      }
    }
  };
</script>